import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "menu-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_button_group = _resolveComponent("el-button-group");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "page-box",
    style: _normalizeStyle({
      visibility: $props.isLineType ? 'hidden' : ''
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList, (menuItem, i) => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: i,
      class: "mx-1",
      effect: menuItem.taskNo == $setup.taskNo ? 'dark' : 'light',
      type: menuItem.isFinish ? '' : 'info',
      onClick: $event => $setup.change(menuItem),
      round: ""
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(i + 1 + $setup.preTotalNo), 1)]),
      _: 2
    }, 1032, ["effect", "type", "onClick"]);
  }), 128))], 4), _createVNode(_component_el_button_group, null, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      disabled: $setup.menuList[0].itemNo == $props.itemNo,
      onClick: $setup.back,
      style: _normalizeStyle({
        visibility: $props.isLineType ? 'hidden' : ''
      })
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("Back", -1)]))]),
      _: 1
    }, 8, ["disabled", "onClick", "style"]), _createVNode(_component_el_button, {
      type: "primary",
      disabled: $props.examType == 3 && $setup.menuList[$setup.menuList.length - 1].itemNo == $props.itemNo,
      loading: $props.vsptLoading,
      onClick: $setup.next
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("Next", -1)]))]),
      _: 1
    }, 8, ["disabled", "loading", "onClick"])]),
    _: 1
  })]);
}